import type { PanelPlugin } from './types'
import { voicePanel } from './voicePanel'
import { documentPanel } from './documentPanel'
import { canvasPanel } from './canvasPanel'

// Registry of panel contributions. Internal panels are bundled here (code contributions); a new
// internal panel = add it to this array, no layout edits. The host looks panels up by id.
export const panels: PanelPlugin[] = [voicePanel, documentPanel, canvasPanel]

export function getPanel(id: string | null | undefined): PanelPlugin | undefined {
  if (!id) return undefined
  return panels.find((p) => p.id === id)
}

export type { PanelPlugin, PanelContext } from './types'
